import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import LinearScaleOutlinedIcon from '@mui/icons-material/LinearScaleOutlined';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';

// Type → tag label + icon for the question-row pill (builder).
const TYPE_META = {
    'paragraph': { label: 'Open vraag', Icon: NotesOutlinedIcon },
    'scale': { label: 'Schaal', Icon: LinearScaleOutlinedIcon },
    'number': { label: 'Numeriek', Icon: NumbersOutlinedIcon },
    'multiple-multiple': { label: 'Meerkeuze', Icon: CheckBoxOutlinedIcon },
    'multiple-one': { label: 'Eén antwoord', Icon: RadioButtonCheckedIcon },
    'matrix-one': { label: 'Matrix', Icon: GridOnOutlinedIcon },
}

const QuestionTypeTag = ({ type }) => {
    const meta = TYPE_META[type] || TYPE_META['paragraph']
    const Icon = meta.Icon
    return <span className="qb-type-tag"><Icon />{meta.label}</span>
}

export default QuestionTypeTag
